/** Candidate shape from GET /miqaats/rsvp-dashboard (flags only used for ranking). */
export type FeaturedMiqaatCandidate = {
  id: string;
  occurrenceDate: string;
  mealType?: string | null;
  isToday: boolean;
  rsvpOpen: boolean;
};

/** Lunch before dinner when occurrence dates tie. */
function mealRank(mealType: string | null | undefined): number {
  const m = String(mealType ?? "")
    .trim()
    .toUpperCase();
  if (m === "LUNCH") return 0;
  if (m === "DINNER") return 1;
  return 2;
}

/**
 * Priority: today+open → today → open → soonest upcoming.
 * Ties: earlier occurrenceDate, then lunch before dinner.
 */
function rankScore(c: FeaturedMiqaatCandidate): number {
  if (c.isToday && c.rsvpOpen) return 0;
  if (c.isToday) return 1;
  if (c.rsvpOpen) return 2;
  return 3;
}

function compareCandidates(a: FeaturedMiqaatCandidate, b: FeaturedMiqaatCandidate): number {
  const byRank = rankScore(a) - rankScore(b);
  if (byRank !== 0) return byRank;
  const byDate = a.occurrenceDate.localeCompare(b.occurrenceDate);
  if (byDate !== 0) return byDate;
  return mealRank(a.mealType) - mealRank(b.mealType);
}

/** Returns the featured miqaat id, or null when there are no candidates. */
export function pickFeaturedMiqaatId(
  candidates: readonly FeaturedMiqaatCandidate[]
): string | null {
  if (candidates.length === 0) return null;
  const sorted = [...candidates].sort(compareCandidates);
  return sorted[0]?.id ?? null;
}
